/*
 * @Description: Cancel Subscription Reason Modal internationalization
 * @FilePath: /weryai-web/locales/modules/cancelSubscription.ts
 */
export default {
    zh: {
        title: '很遗憾看到您要离开',
        subtitle: '在您取消之前，请告诉我们发生了什么。您的反馈对我们至关重要。',
        reasons: {
            priceTooHigh: '价格太高',
            lowUsage: '使用频率低',
            betterAlternative: '找到了更好的替代品',
            featuresModelsIncomplete: '功能/模型不全',
            siteLag: '网站严重卡顿',
            other: '其他',
        },
        otherFeedback: '还有其他想说的吗？',
        placeholder: '您的反馈将帮助我们改进...',
        thinkAgain: '我再想想',
        submitting: '提交中...',
        confirmCancel: '确认取消',
        cancelButton: '取消订阅',
        contactSupport: '联系客服',
    },
    en: {
        title: "We're sorry to see you go",
        subtitle: 'Before you cancel, please let us know what happened. Your feedback is vital to us.',
        reasons: {
            priceTooHigh: 'Price is too high',
            lowUsage: 'Low usage frequency',
            betterAlternative: 'Found a better alternative',
            featuresModelsIncomplete: 'Features/Models are incomplete',
            siteLag: 'Site is seriously lagging',
            other: 'Other',
        },
        otherFeedback: 'Anything else you want to say?',
        placeholder: 'Your feedback will help us improve...',
        thinkAgain: 'Let me think again',
        submitting: 'Submitting...',
        confirmCancel: 'Confirm Cancellation',
        cancelButton: 'Cancel Subscription',
        contactSupport: 'Contact support',
    },
    ja: {
        title: '退会されるのは非常に残念です',
        subtitle: 'キャンセルする前に、何があったか教えてください。あなたのフィードバックは私たちにとって非常に重要です。',
        reasons: {
            priceTooHigh: '价格が高すぎる',
            lowUsage: '使用頻度が低い',
            betterAlternative: 'より良い替代品を見つけた',
            featuresModelsIncomplete: '機能/モデルが不十分',
            siteLag: 'サイトの動作が非常に重い',
            other: 'その他',
        },
        otherFeedback: '他に何か伝えたいことはありますか？',
        placeholder: 'あなたのフィードバックは改善に役立ちます...',
        thinkAgain: 'もう少し考え直す',
        submitting: '送信中...',
        confirmCancel: 'キャンセルを确定する',
        cancelButton: 'サブスクリプションキャンセル',
        contactSupport: 'サポートに連絡',
    },
    ko: {
        title: '떠나신다니 정말 아쉽습니다',
        subtitle: '취소하시기 전에 무슨 일이 있었는지 알려주세요. 귀하의 피드백은 저희에게 매우 소중합니다.',
        reasons: {
            priceTooHigh: '가격이 너무 비쌈',
            lowUsage: '사용 빈도가 낮음',
            betterAlternative: '더 나은 대안을 찾음',
            featuresModelsIncomplete: '기능/모델이 불완전함',
            siteLag: '사이트가 심하게 느림',
            other: '기타',
        },
        otherFeedback: '더 하실 말씀이 있으신가요?',
        placeholder: '귀하의 피드백은 개선에 도움이 됩니다...',
        thinkAgain: '다시 생각해보기',
        submitting: '제출 중...',
        confirmCancel: '취소 확인',
        cancelButton: '구독 취소',
        contactSupport: '고객지원 문의',
    },
    es: {
        title: 'Lamentamos verlo partir',
        subtitle: 'Antes de cancelar, por favor cuéntenos qué pasó. Sus comentarios son vitales para nosotros.',
        reasons: {
            priceTooHigh: 'El precio es demasiado alto',
            lowUsage: 'Baja frecuencia de uso',
            betterAlternative: 'Encontré una mejor alternativa',
            featuresModelsIncomplete: 'Funciones/Modelos incompletos',
            siteLag: 'El sitio va muy lento',
            other: 'Otro',
        },
        otherFeedback: '¿Hay algo más que quiera decir?',
        placeholder: 'Sus comentarios nos ayudarán a mejorar...',
        thinkAgain: 'Déjame pensarlo de nuevo',
        submitting: 'Enviando...',
        confirmCancel: 'Confirmar cancelación',
        cancelButton: 'Cancelar Suscripción',
        contactSupport: 'contactar soporte',
    },
    fr: {
        title: 'Nous sommes désolés de vous voir partir',
        subtitle: "Avant de l'annuler, s'il vous plaît dites-nous ce qui s'est passé. Vos commentaires sont essentiels pour nous.",
        reasons: {
            priceTooHigh: 'Le prix est trop élevé',
            lowUsage: "Faible fréquence d'utilisation",
            betterAlternative: "J'ai trouvé une meilleure alternative",
            featuresModelsIncomplete: 'Fonctionnalités/Modèles incomplets',
            siteLag: 'Le site est très lent',
            other: 'Autre',
        },
        otherFeedback: 'Avez-vous autre chose à dire ?',
        placeholder: 'Vos commentaires nous aideront à nous améliorer...',
        thinkAgain: 'Je vais y réfléchir encore',
        submitting: 'Envoi en cours...',
        confirmCancel: "Confirmer l'annulation",
        cancelButton: "Annuler l'Abonnement",
        contactSupport: 'contacter le support',
    },
    de: {
        title: 'Es tut uns leid, dass Sie gehen',
        subtitle: 'Bevor Sie kündigen, lassen Sie uns bitte wissen, what passiert ist. Ihr Feedback ist für uns von entscheidender Bedeutung.',
        reasons: {
            priceTooHigh: 'Der Preis ist zu hoch',
            lowUsage: 'Geringe Nutzungshäufigkeit',
            betterAlternative: 'Habe eine bessere Alternative gefunden',
            featuresModelsIncomplete: 'Funktionen/Modelle unvollständig',
            siteLag: 'Die Seite verzögert stark',
            other: 'Sonstiges',
        },
        otherFeedback: 'Möchten Sie sonst noch etwas sagen?',
        placeholder: 'Ihr Feedback hilft uns, uns zu verbessern...',
        thinkAgain: 'Ich überlege es mir noch einmal',
        submitting: 'Wird übermittelt...',
        confirmCancel: 'Kündigung bestätigen',
        cancelButton: 'Abonnement Kündigen',
        contactSupport: 'Support kontaktieren',
    },
    ru: {
        title: 'Нам жаль, что вы уходите',
        subtitle: 'Прежде чем вы отмените подписку, пожалуйста, расскажите нам, что произошло. Ваш отзыв очень важен для нас.',
        reasons: {
            priceTooHigh: 'Слишком высокая цена',
            lowUsage: 'Низкая частота использования',
            betterAlternative: 'Нашел лучшую альтернативу',
            featuresModelsIncomplete: 'Функции/модели неполные',
            siteLag: 'Сайт сильно тормозит',
            other: 'Другое',
        },
        otherFeedback: 'Хотите что-нибудь еще добавить?',
        placeholder: 'Ваш отзыв поможет нам стать лучше...',
        thinkAgain: 'Я еще подумаю',
        submitting: 'Отправка...',
        confirmCancel: 'Подтвердить отмену',
        cancelButton: 'Отменить подписку',
        contactSupport: 'связаться с поддержкой',
    },
    pt: {
        title: 'Lamentamos ver você partir',
        subtitle: 'Antes de cancelar, por favor, conte-nos o que aconteceu. Seu feedback é vital para nós.',
        reasons: {
            priceTooHigh: 'O preço está muito alto',
            lowUsage: 'Baixa frequência de uso',
            betterAlternative: 'Encontré uma alternativa melhor',
            featuresModelsIncomplete: 'Recursos/Modelos incompletos',
            siteLag: 'O site está muito lento',
            other: 'Outro',
        },
        otherFeedback: 'Mais alguma coisa que queira dizer?',
        placeholder: 'Seu feedback nos ajudará a melhorar...',
        thinkAgain: 'Vou pensar melhor',
        submitting: 'Enviando...',
        confirmCancel: 'Confirmar cancelamento',
        cancelButton: 'Cancelar Assinatura',
        contactSupport: 'entrar em contato com o suporte',
    },
    it: {
        title: 'Ci dispiace vederti andare via',
        subtitle: 'Prima di annullare, facci sapere cosa è successo. Il tuo feedback è vitale per noi.',
        reasons: {
            priceTooHigh: 'Il prezzo è troppo alto',
            lowUsage: "Bassa frequenza d'uso",
            betterAlternative: "Ho trovato un'alternativa migliore",
            featuresModelsIncomplete: 'Funzioni/Modelli incompleti',
            siteLag: 'Il sito è molto lento',
            other: 'Altro',
        },
        otherFeedback: "C'è altro che vorresti dire?",
        placeholder: 'Il tuo feedback ci aiuterà a migliorare...',
        thinkAgain: 'Ci ripenserò',
        submitting: 'Invio in corso...',
        confirmCancel: 'Conferma annullamento',
        cancelButton: 'Annulla Abbonamento',
        contactSupport: 'contatta il supporto',
    },
    ar: {
        title: 'يؤسفنا رؤيتك تغادر',
        subtitle: 'قبل الإلغاء، يرجى إخبارنا بما حدث. ملاحظاتك حيوية بالنسبة لنا.',
        reasons: {
            priceTooHigh: 'السعر مرتفع للغاية',
            lowUsage: 'قلة تكرار الاستخدام',
            betterAlternative: 'وجدت بديلاً أفضل',
            featuresModelsIncomplete: 'الميزات/النماذج غير مكتملة',
            siteLag: 'الموقع يعاني من بطء شديد',
            other: 'آخر',
        },
        otherFeedback: 'هل هناك أي شيء آخر تود قوله؟',
        placeholder: 'ستساعدنا ملاحظاتك على التحسين...',
        thinkAgain: 'سأفكر مرة أخرى',
        submitting: 'جاري الإرسال...',
        confirmCancel: 'تأكيد الإلغاء',
        cancelButton: 'إلغاء الاشتراك',
        contactSupport: 'اتصل بالدعم',
    },
    tw: {
        title: '很遺憾看到您要離開',
        subtitle: '在您取消之前，請告訴我們發生了什麼。您的回饋對我們至關重要。',
        reasons: {
            priceTooHigh: '價格太高',
            lowUsage: '使用頻率低',
            betterAlternative: '找到了更好的替代品',
            featuresModelsIncomplete: '功能/模型不全',
            siteLag: '網站嚴重卡頓',
            other: '其他',
        },
        otherFeedback: '還有其他想說的嗎？',
        placeholder: '您的回饋將幫助我們改進...',
        thinkAgain: '我再想想',
        submitting: '提交中...',
        confirmCancel: '確認取消',
        cancelButton: '取消訂閱',
        contactSupport: '聯絡客服',
    },
    pl: {
        title: 'Przykro nam, że odchodzisz',
        subtitle: 'Zanim anulujesz, daj nam znać, co się stało. Twoja opinia jest dla nas kluczowa.',
        reasons: {
            priceTooHigh: 'Cena jest za wysoka',
            lowUsage: 'Niska częstotliwość użytkowania',
            betterAlternative: 'Znalazłem lepszą alternatywę',
            featuresModelsIncomplete: 'Funkcje/Modele są niepełne',
            siteLag: 'Strona bardzo wolno działa',
            other: 'Inne',
        },
        otherFeedback: 'Czy chcesz dodać coś jeszcze?',
        placeholder: 'Twoja opinia pomoże nam w ulepszeniach...',
        thinkAgain: 'Jeszcze to przemyślę',
        submitting: 'Wysyłanie...',
        confirmCancel: 'Potwierdź anulowanie',
        cancelButton: 'Anuluj subskrypcję',
        contactSupport: 'Skontaktuj się z pomocą',
    },
    th: {
        title: 'เราเสียใจที่เห็นคุณจากไป',
        subtitle: 'ก่อนที่คุณจะยกเลิก โปรดแจ้งให้เราทราบว่าเกิดอะไรขึ้น ความคิดเห็นของคุณมีความสำคัญต่อเรามาก',
        reasons: {
            priceTooHigh: 'ราคาสูงเกินไป',
            lowUsage: 'ความถี่ในการใช้งานต่ำ',
            betterAlternative: 'พบทางเลือกอื่นที่ดีกว่า',
            featuresModelsIncomplete: 'ฟีเจอร์/โมเดลไม่ครบถ้วน',
            siteLag: 'เว็บไซต์กระตุกอย่างหนัก',
            other: 'อื่นๆ',
        },
        otherFeedback: 'มีอะไรอื่นที่คุณต้องการบอกเราไหม?',
        placeholder: 'ความคิดเห็นของคุณจะช่วยให้เราปรับปรุงให้ดีขึ้น...',
        thinkAgain: 'ขอฉันคิดดูอีกครั้ง',
        submitting: 'กำลังส่ง...',
        confirmCancel: 'ยืนยันการยกเลิก',
        cancelButton: 'ยกเลิกการสมัครสมาชิก',
        contactSupport: 'ติดต่อฝ่ายสนับสนุน',
    },
    da: {
        title: 'Vi er kede af at se dig gå',
        subtitle: 'Før du annullerer, bedes du fortælle os, hvad der skete. Din feedback er afgørende for os.',
        reasons: {
            priceTooHigh: 'Prisen er for høj',
            lowUsage: 'Lav brugsfrekvens',
            betterAlternative: 'Har fundet et bedre alternativ',
            featuresModelsIncomplete: 'Funktioner/Modeller er ufuldstændige',
            siteLag: 'Siden lagger alvorligt',
            other: 'Andet',
        },
        otherFeedback: 'Er der andet, du vil sige?',
        placeholder: 'Din feedback vil hjælpe os med at forbedre os...',
        thinkAgain: 'Lad mig tænke over det igen',
        submitting: 'Indsender...',
        confirmCancel: 'Bekræft annullering',
        cancelButton: 'Annuller abonnement',
        contactSupport: 'Kontakt support',
    },
    no: {
        title: 'Vi synes det er trist at du drar',
        subtitle: 'Før du kansellerer, vennligst la oss få vite hva som skjedde. Din tilbakemelding er viktig for oss.',
        reasons: {
            priceTooHigh: 'Prisen er for høy',
            lowUsage: 'Lav bruksfrekvens',
            betterAlternative: 'Fant et bedre alternativ',
            featuresModelsIncomplete: 'Funksjoner/Modeller er ufullstendige',
            siteLag: 'Siden lagger alvorlig',
            other: 'Annet',
        },
        otherFeedback: 'Er det noe annet du vil si?',
        placeholder: 'Din tilbakemelding vil hjelpe oss med å forbedre oss...',
        thinkAgain: 'La meg tenke over det igen',
        submitting: 'Sender inn...',
        confirmCancel: 'Bekreft kansellering',
        cancelButton: 'Kanseller abonnement',
        contactSupport: 'Kontakt support',
    },
    nl: {
        title: 'Het spijt ons dat u weggaat',
        subtitle: 'Laat ons voordat u opzegt weten wat er is gebeurd. Uw feedback is essentieel voor ons.',
        reasons: {
            priceTooHigh: 'De prijs is te hoog',
            lowUsage: 'Lage gebruiksfrequentie',
            betterAlternative: 'Een beter alternatief gevonden',
            featuresModelsIncomplete: 'Functies/Modellen zijn onvolledig',
            siteLag: 'De site heeft ernstige vertraging',
            other: 'Anders',
        },
        otherFeedback: 'Wilt u nog iets anders kwijt?',
        placeholder: 'Uw feedback helpt ons te verbeteren...',
        thinkAgain: 'Laat me er nog eens over nadat denken',
        submitting: 'Verzenden...',
        confirmCancel: 'Bevestig annulering',
        cancelButton: 'Abonnement opzeggen',
        contactSupport: 'Contact opnemen met support',
    },
    id: {
        title: 'Kami menyesal melihat Anda pergi',
        subtitle: 'Sebelum Anda membatalkan, beri tahu kami apa yang terjadi. Umpan balik Anda sangat penting bagi kami.',
        reasons: {
            priceTooHigh: 'Harga terlalu tinggi',
            lowUsage: 'Frekuensi penggunaan rendah',
            betterAlternative: 'Menemukan alternatif yang lebih baik',
            featuresModelsIncomplete: 'Fitur/Model tidak lengkap',
            siteLag: 'Situs sangat lambat',
            other: 'Lainnya',
        },
        otherFeedback: 'Ada lagi yang ingin Anda sampaikan?',
        placeholder: 'Umpan balik Anda akan membantu kami meningkatkan...',
        thinkAgain: 'Biarkan saya pikirkan lagi',
        submitting: 'Mengirim...',
        confirmCancel: 'Konfirmasi pembatalan',
        cancelButton: 'Batalkan Langganan',
        contactSupport: 'Hubungi dukungan',
    },
    tr: {
        title: 'Gittiğiniz için üzgünüz',
        subtitle: 'İptal etmeden önce lütfen ne olduğunu bize bildirin. Geri bildiriminiz bizim için hayati önem taşıyor.',
        reasons: {
            priceTooHigh: 'Fiyat çok yüksek',
            lowUsage: 'Düşük kullanım sıklığı',
            betterAlternative: 'Daha iyi bir alternatif bulundu',
            featuresModelsIncomplete: 'Özellikler/Modeller eksik',
            siteLag: 'Site ciddi şekilde kasıyor',
            other: 'Diğer',
        },
        otherFeedback: 'Söylemek istediğiniz başka bir şey var mı?',
        placeholder: 'Geri bildiriminiz gelişmemize yardımcı olacaktır...',
        thinkAgain: 'Tekrar düşüneyim',
        submitting: 'Gönderiliyor...',
        confirmCancel: 'İptali Onayla',
        cancelButton: 'Aboneliği İptal Et',
        contactSupport: 'Destek ile iletişime geçin',
    },
}
